import httpMethod from 'services/update2025/httpMethod';
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { SendReceptDataContext } from "./SendReceptDataContext";

export const SendReceptDataMessage = () => {
    const toast = useRef(null);
    const { t, i18n } = useTranslation(["send-recept-data", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const sendReceptDataContext = useContext(SendReceptDataContext);
    const { sendReceptData, setSendReceptData, sendReceptDataDialog, setSendReceptDataDialog } = sendReceptDataContext;

    const hideDialog = () => {
        setSendReceptDataDialog(false);
    };

    return (
        <Dialog visible={sendReceptDataDialog} style={{ width: "70%" }} header={t("send-receipt-data.detailError")} modal className="p-fluid text-center" onHide={hideDialog}>
            <div className="formgrid">
                <div className="grid text-left">
                    <div className="col-12">
                        <div className="grid">{sendReceptData}</div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        {/* close */}
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            className="mr-2 p-button-danger"
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </div>
        </Dialog>
    );
};
